export class CatalogoCobro {

    public id:number;
    public codigoConsorcio:string;
    public conceptoCobro:string;
    public tipoUnidadCobro:string;
    public descripcionCobro:string;
    public costoEstandar:number;
    public codigoMoneda:string;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/catalogo-cobro.ts